import { LucideRows3, LucideRows4 } from "lucide-react";

const OPTIONS = [
  { value: "md", icon: LucideRows3, label: "Comfortable rows" },
  { value: "sm", icon: LucideRows4, label: "Compact rows" },
];

export function StudentListSizeToggle({ size, onChange, className = "" }) {
  return (
    <div
      role="group"
      aria-label="Student list density"
      className={`inline-flex h-10 items-center rounded-md border border-input bg-background p-0.5 ${className}`}
    >
      {OPTIONS.map(({ value, icon: Icon, label }) => {
        const active = size === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => onChange(value)}
            aria-label={label}
            aria-pressed={active}
            className={`flex h-full items-center justify-center rounded-sm px-2.5 transition-colors ${
              active
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon size={16} />
          </button>
        );
      })}
    </div>
  );
}
